import React, { useRef, useEffect, useState } from 'react';
import { ReactComponent as ArrowLeft } from '../../assets/arrow-left-carousel.svg';
import { ReactComponent as ArrowRight } from '../../assets/arrow-right-carousel.svg';
import './carousel.scss';
import messenger from '../../services/messenger';

const scrollAmount = 217;

const Carousel = ({ children, itemClass = '', showArray = false }) => {
	const itemsRef = useRef();
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(false);

	useEffect(() => {
		// itemsRef.current.addEventListener(
		// 	'wheel',
		// 	e => {
		// 		e.preventDefault();
		// 	},
		// 	{ passive: false }
		// );
		setCanScrollRight(itemsRef.current.scrollWidth > itemsRef.current.offsetWidth);
	}, []);

	// const onWheel = e => {
	// 	e.stopPropagation();
	// 	let delta = e.deltaY || e.deltaX;
	// 	itemsRef.current.scrollLeft += delta;
	// 	setCanScrollRight(
	// 		itemsRef.current.scrollWidth > itemsRef.current.offsetWidth &&
	// 			itemsRef.current.offsetWidth + itemsRef.current.scrollLeft !== itemsRef.current.scrollWidth
	// 	);

	// 	setCanScrollLeft(
	// 		itemsRef.current.scrollWidth > itemsRef.current.offsetWidth && itemsRef.current.scrollLeft > 0
	// 	);
	// };

	const onArrowClick = side => {
		let newLeft =
			side === 'left' ? itemsRef.current.scrollLeft - scrollAmount : itemsRef.current.scrollLeft + scrollAmount;
		itemsRef.current.scrollTo({
			top: 0,
			left: newLeft,
			behavior: 'smooth'
		});

		setCanScrollLeft(itemsRef.current.scrollWidth > itemsRef.current.offsetWidth && newLeft > 0);
		setCanScrollRight(
			itemsRef.current.scrollWidth > itemsRef.current.offsetWidth &&
				itemsRef.current.offsetWidth + itemsRef.current.scrollLeft !== itemsRef.current.scrollWidth
		);
		messenger.log({ eventAction: `Slide Games`, eventLabel: side });
	};

	return (
		<div className="carousel">
			{showArray && canScrollLeft && (
				<div
					className="carousel__arrow-container carousel__arrow-container--left"
					onClick={() => onArrowClick('left')}
				>
					<ArrowLeft className="carousel__arrow" />
				</div>
			)}
			{showArray && canScrollRight && (
				<div
					className="carousel__arrow-container carousel__arrow-container--right"
					onClick={() => onArrowClick('right')}
				>
					<ArrowRight className="carousel__arrow" />
				</div>
			)}
			<div className="carousel__items" ref={itemsRef}>
				{children}
				{/* &&
					children.map((slide, index) => {
						return React.cloneElement(slide, {
							key: index,
							className: itemClass
						});
					})} */}
			</div>
		</div>
	);
};

export default Carousel;
